import { render, staticRenderFns } from "./IndividualPayrollForms.vue?vue&type=template&id=2a0f3615&scoped=true&"
import script from "./IndividualPayrollForms.vue?vue&type=script&lang=ts&"
export * from "./IndividualPayrollForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f3615",
  null
  
)

export default component.exports